import 'fullpage.js/dist/jquery.fullpage.js';
import 'fullpage.js/dist/jquery.fullpage.css';

class LandingController {
  constructor($window) {
    'ngInject';

    this.$window = $window;
  }

  $postLink() {
    $('.landing').fullpage({
      sectionSelector: '.landing-section',
      fixedElements: '.guest__header-container',
      navigation: true,
      responsiveWidth: 900,
      onLeave: function(index, nextIndex, direction) {
        let header = $('.guest-header');

        if (nextIndex > 1) {
          header.addClass('guest-header--underlined');
        } else {
          header.removeClass('guest-header--underlined');
        }
      }
    });
  }

  $onDestroy() {
    $('.guest__header-container').remove();
    $('.guest-header').removeClass('guest-header--underlined');
    $.fn.fullpage.destroy('all');
  }
}


export default LandingController;



// WEBPACK FOOTER //
// ./src/app/screens/guest/screens/landing/landing.controller.js